import {XauditModel} from '../../xaudit.model';

export class TdoUserGroupRoleConfigurationModel extends XauditModel {
  UserGroupId: string;
  RoleId: string;
}
